import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import { t } from 'c-3po';
import { CHAT_STATUS_ACTIVE } from '@evo/chat-core';
import {getSocketStore} from "../../../libs/utils";

import * as a from './../../../libs/actions';
import * as aggs from "../../../libs/aggregation";
import { Head } from '../../ui/head';


class HeaderView extends React.Component {

    static propTypes = {
        closeDialog: PropTypes.func,
        hasUnreadMessage: PropTypes.bool,
    };

    handleChangeCompanyTab = () => {
        this.props.send(a.EVENT_COMPANY_BACK_TAB);
    }

    render() {
        const { closeDialog, hasUnreadMessage } = this.props;

        return (
            <Head
                dataQa='chat_header'
                hasUnreadMessage={hasUnreadMessage}
                onBack={this.handleChangeCompanyTab}
                onClose={closeDialog}
            >
                <span title={t`Информация о покупателе`}>
                    {t`Информация о продавце`}
                </span>
            </Head>
        );
    }
}

const mapStateToProps = (state) => {
    const socketStore = getSocketStore(state);

    return {
        hasUnreadMessage: aggs.hasUnreadMessage(
            socketStore.get('chats'),
            CHAT_STATUS_ACTIVE
        )
    }
};


export const Header = connect(mapStateToProps)(HeaderView);
